import React, { useEffect, useMemo, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Spinner,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import paginationFactory from "react-bootstrap-table2-paginator";
import calculatePrice from "../../../../helpers/calculate_price";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import EnterQuantityForPoModal from "../../../../components/EnterQuantityForPoModal";
import UpdateQuantityForPoModal from "../../../../components/UpdateQuantityForPoModal";
import AllDrafts from "../../Draft/AllDrafts";

const FinishedProductPOGeneration = (props) => {
  
  const [cartItems, setCartItems] = useState([]);
  const [cartModal, setCartModal] = useState(false)
  const [disableSubmit, setDisableSubmit] = useState(false);

  useEffect(() => {
    loadProducts();
    loadDraftOrders();
  }, []);

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [editUnitModal, setEditUnitModal] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchkey, setSearchKey] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [selectedDraftID, setSelectedDraftID] = useState("");
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(50);


  const loadProducts = async () => {
   try {
     setIsLoadingProducts(true);
    let url = process.env.REACT_APP_BASEURL + "products/get_for_po";
    const response = await postSubmitForm(url, {})
    if (response && response.status === 1) {
      const updatedItems = (response.data || []).filter((item) => item.is_active !== false).map((item) => ({
        ...item,
        item_id: item._id,
        total_price :0,
      }));
      const SortedData = updatedItems.sort((a,b)=>a.name.localeCompare(b.name))
      setAllProducts(SortedData);
      setFilteredProducts(SortedData);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.log(error);
   } finally {
    setIsLoadingProducts(false)
   }
  };

  useEffect(() => {
    filterItems(allProducts);
  }, [searchkey]);

  const filterItems = async (allProducts) => {
    let filteredProducts;
    if (!searchkey || searchkey.trim() === "") {
      filteredProducts = allProducts;
    } else {
      filteredProducts = allProducts?.filter((item) => {
        return (
          item.name.toLowerCase().includes(searchkey.toLowerCase()) ||
          item.category.toLowerCase().includes(searchkey.toLowerCase())
        );
      });
    }
    setFilteredProducts(filteredProducts);
  };

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return (pageNumber - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "45%" };
      },
      editable: false,
    },
      {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
     {
      text: props.t("Price"),
      dataField: "price",
      formatter:(cell,row)=>{
        return (row.price)+" / "+row.unit_for_cost_price
      },
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      footer: false,
    },
  ];

  const handleDeleteRow = (itemId) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.item_id !== itemId);
      return updatedCartItems;
    });
  };
  
  const columns_cartitems = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
      sort: false,
      footer: false,
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "23%" };
      },
      footer: false,
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      footer: false,
    },
     {
      text: props.t("Category"),
      dataField: "category",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      footer: false,
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <span className="me-2">
                {formatUnitsForReport(row.quantity)}
              </span>
                <Button
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    setSelectedProducts(row)
                    setEditUnitModal(true);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
            </div>
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    
    {
      text: props.t("Price"),
      dataField: "price",
      formatter:(cell,row)=>{
        return (row.price)+" / "+row.unit_for_cost_price
      },
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      footer: false,
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      sort: false,
      formatter:(cell,row)=>{
        return row.total_price.toFixed(2)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
      footer: (columnData) => {
        const total = columnData.reduce((acc, item) => acc + item, 0);
        return total.toFixed(2);
      },
    },
    {
      dataField: "",
      editable:false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
               handleDeleteRow(row.item_id)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      sort: false,
      footer: false,
    },
  ];
// console.log(cartItems,"ci");

    const selectDraftPORow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectAll: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        handleDraftPOSelection(row);
      }
    },
    selected: [selectedDraftID],
  };

    const handleDraftPOSelection = (row) => {
      setSelectedDraftID(row._id);
       const updatedItems = row.products.map((item) => ({
        ...item,
        item_id: item.product_id,
        quantity: (item.quantity || []).map((qty, index) => ({
          ...qty,
          index,
          isChecked: Number(qty.value) > 0,
        })),
      }));
      setCartItems(updatedItems);
      setOpenDraftModal(false);
      setCartModal(true)
    };

      // const populateCartFromDraft = async (draftPO) => {

    // const newCartCategorizesItems = products.map((category) => ({
    //   category: category.category,
    //   selSupp: category.supplier, 
    //   items: category.items.map((item) => ({
    //     ...item,
    //     category: category.category,
    //   })),
    //   suppliers: [], 
    // }));
// setCartItems(newCartCategorizesItems.flatMap((category) => category.items));
// setCategorisezItem(newCartCategorizesItems);   
  // };

  const cartItemIds = useMemo(
    () => cartItems.map((item) => item.item_id),
    [cartItems]
  );
  const filteredItemIdSet = useMemo(
    () => new Set((filteredProducts || []).map((item) => item.item_id)),
    [filteredProducts]
  );
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: '#ecf0a1',
    selected: cartItemIds,
    nonSelectable: cartItemIds.filter((itemId) => filteredItemIdSet.has(itemId)),
    onSelect: (row, isSelect, rowIndex, e) => {
        if (isSelect) {
          setSelectedProducts(row);
          SelectDefaultUnit(row);
          updateSelectedProducts(row, isSelect);
        } else {
          e.preventDefault();
        }

    },
  };

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [openDraftModal, setOpenDraftModal] = useState(false);
  const [draftOrders, setDraftOrders] = useState([]);
  const loadDraftOrders = async () => {
    let url = process.env.REACT_APP_BASEURL + "productpurchaseorderdrafts/get_draft";
    let response = await postSubmitForm(url, {});
    if (response.status === 1) {
      setDraftOrders(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

    const [isLoading , setIsLoading] = useState(false)
  const handleSubmitDraft = async () => {
 let payload =  cartItems.map((item) => ({
        product_id: item.item_id,
        name: item.name,
        category: item.category,
        section: item.section,
        unit_for_cost_price: item.unit_for_cost_price,
        unit_levels: item.unit_levels, 
        quantity: item.quantity.map(({ unit, value }) => ({ unit, value })) || null, 
        price: +item.price,
        total_price: +item.total_price,
              })
            )
       // console.log(payload);
    //  return

    try {
      setIsLoading(true)
      if (categorisezItem.length > 0) {
        let url = process.env.REACT_APP_BASEURL + "productpurchaseorderdrafts/save_draft";
        let data_to_send = { products: payload };
        data_to_send.draft_id = selectedDraftID;
        let response = await postSubmitForm(url, data_to_send);
        if (response.status === 1) {
          setDisableSubmit(false);
          setSelectedDraftID("");
          loadDraftOrders();
          showNotification(response.message, "Success");
          setCartItems([]);
          setCategorisezItem([]);
          setCartModal(!cartModal);
          setSelectedProducts([]);
          setSelectedRowsUnit([]);      
        } else {
          showNotification(response.message, "Error");
        }
      } else {
        showNotification(
          "Please select at least one item and supplier.",
          "Error"
        );
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  function SelectDefaultUnit(row) {
    setSelectedRowsUnit([
      {
        index: 0,
        unit: row.unit_levels[0].unit,
        formula: row.unit_levels[0].value,
        value: 0,
        isChecked: true,
      },
    ]);
    setSelectUnitModal(true);
  }

  function updateSelectedProducts(row, isSelect) {
    setCartItems((prevSelected) => {
      if (isSelect) {
        if (!prevSelected.some(item => item.item_id === row.item_id)) {
          return [...prevSelected, row];
        }
      } else {
        const isnoUnitsSelected = selectedRowsUnit.every(unit => !unit.isChecked);
        if (isnoUnitsSelected) {
          return prevSelected.filter(item => item.item_id !== row.item_id);
        }
      }
      return prevSelected;
    });
  }

const [isSubmitting, setIsSubmitting] = useState(false)
  const handleSubmitRequisition = async () => {
   
    let payload = {
 products: cartItems.map((item) => ({
        product_id: item.item_id,
        name: item.name,
        category: item.category,
        section: item.section,
        unit_for_cost_price: item.unit_for_cost_price,
        unit_levels: item.unit_levels, 
        quantity: item.quantity.map(({ unit, value }) => ({ unit, value })) || null, 
        price: +item.price,
        total_price: +item.total_price,
              })
            )
    }

  // console.log(payload);
  //  return
   
      try {
      if (categorisezItem.some((category) =>
            category.items.some((item) =>
              item.quantity.every(({ value }) => (value == "0" || value === ""|| value === 0))
            )
          )
        ) {showNotification("Please enter a valid quantity for atleast one unit", "Warning");
          return;
        }
        if (categorisezItem.length > 0) {
          setIsSubmitting(true);
         payload.draft_id = selectedDraftID;
          let url = process.env.REACT_APP_BASEURL + "productpurchaseorders/insert";
          let response = await postSubmitForm(url, payload);
          if (response.status === 1) {
             window.open(`/purchase_order?fp_po_id=${response.data}`,"_blank");
            showNotification(response.message, "Success");
            setCartItems([])
            setSelectedDraftID('')
            loadDraftOrders()
            setCategorisezItem([])
            setCartModal(!cartModal)
            setSelectedProducts([])
            setSelectedRowsUnit([])
            // window.location.reload();
          } else {
            showNotification(response.message, "Error");
          }
        } else {
          showNotification(
            "Please select at least one item and supplier.",
            "Error"
          );
        }
      } catch (error) {
        showNotification(error.message, "Error");
      } finally {
        setIsSubmitting(false);
      }
 
  };


const handleAddUnits = (qty) => {
  let convertedQuantity =  GetUpdatedDelivered(qty, selectedProducts?.unit_levels)
  const updatedCartItems = cartItems.map(item => {
    if (item.item_id === selectedProducts.item_id) {
      const total_price = calculatePrice(selectedProducts.unit_levels,selectedRowsUnit, item.price,item.unit_for_cost_price);
      return { ...item, quantity: convertedQuantity, total_price };
    } else {
      return item;
    }
  });

  setCartItems(updatedCartItems);
  setSelectUnitModal(false);
  setSelectedProducts([]);
  setSelectedRowsUnit([]);
};

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    page: pageNumber,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setPageNumber(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  
const [categorisezItem, setCategorisezItem] = useState([])  

function groupBy(array, property) {
  return Object.values(array.reduce((acc, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = { category: key, items: [],suppliers:[] ,selSupp:""};
    }
    acc[key].items.push(obj);
    return acc;
  }, {}));
}


useEffect(()=>{
  setCategorisezItem(()=>groupBy(cartItems,"category"))
},[cartItems])


  function handleCloseModal() {
    const hasValidquantity = selectedProducts?.quantity && 
    selectedProducts.quantity.every(unit => unit.value > 0);
  if (!hasValidquantity) {
    setCartItems((prevCartItems) =>
      prevCartItems.filter((item) => item.item_id !== selectedProducts.item_id)
    );
  }
    setSelectUnitModal(false);
  }


  const handleUpdateUnit = (qty) => {
    let convertedQuantity =  GetUpdatedDelivered(qty, selectedProducts?.unit_levels)
    const isItemInCart = cartItems.some(item => item.item_id === selectedProducts.item_id);
    if (isItemInCart) {
      const updatedCartItems = cartItems.map(item =>
        item.item_id === selectedProducts.item_id
          ? {
              ...item,
              quantity: convertedQuantity,
              total_price: calculatePrice(item.unit_levels,convertedQuantity,item.price,item.unit_for_cost_price),
            }
          : item
      );
      setCartItems(updatedCartItems);
      setEditUnitModal(false);
    } else {
      const newItem = {
        ...selectedProducts,
        quantity: convertedQuantity,
        total_price: calculatePrice(selectedProducts.unit_levels,convertedQuantity,selectedProducts.price,selectedProducts.unit_for_cost_price),
      };
      setCartItems(prevCartItems => [...prevCartItems, newItem]);
      setEditUnitModal(false);
    }
  
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Finished Product Po Generation")}
            title={props.t("Procurement")}
            breadcrumbItem1={props.t("Generate FP PO")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4} md={4} >
                        <AvField
                          name="search"
                          label={props.t("Search")}
                          placeholder={props.t("Search products here...")}
                          type="text"
                          onChange={(e) => {
                            e.preventDefault();
                            setSearchKey(e.target.value);
                          }}
                        ></AvField>
                      </Col>
                      <Col
                        lg={8} md={4} 
                        className="d-flex mt-1 justify-content-end align-items-center"
                      >
                      <div>
                                                <Button
                                                  type="submit"
                                                  color="success"
                                                  className="mr-5"
                                                  onClick={() => setOpenDraftModal(true)}
                                                >
                                                  {props.t("View Draft PO's")}
                                                </Button>{" "}
                      <Button
                        color="primary"
                        disabled={cartItems?.length===0}
                        onClick={() => setCartModal(!cartModal)}
                      >
                        View Cart

                        {/* <span className="badge badge-danger badge-pill"
                          style={{
                            position: "absolute",
                            top: "12px",
                            // right: "8px",
                            // background: "red",
                            // color: "white",
                            // borderRadius: "50%",
                            // padding: "3px 7px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            // lineHeight: 1
                          }}
                        >
                          {cartItems?.length}
                        </span> */}
                      </Button>
                    </div>

                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>

                  <ToolkitProvider
                    bootstrap4
                    keyField="item_id"
                    data={filteredProducts || []}
                    columns={columns_items}
                    noDataIndication={isLoadingProducts ? <Spinner size="md" /> : props.t("No data to display.")}
                    search
                  >
                    {(props) => (
                      <div>
                        <BootstrapTable
                          pagination={paginationFactory(pagination_options)}
                          striped
                          hover
                          condensed
                          selectRow={selectRow}
                          {...props.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Cart Modal  */}

          <Modal
            size="lg"
            isOpen={cartModal}
            toggle={() => setCartModal(!cartModal)}
          >
            <ModalHeader
              toggle={() => setCartModal(!cartModal)}
            >
              {props.t("Review Order Details")}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        {/* category base bifurcation */}
                        {/* <Col lg={12}>
                          {categorisezItem &&
                            categorisezItem.map((item) => {
                              if (item.items.length > 0) {
                                return (
                                  <>
                                    <Row>
                                      <Col lg={8}>
                                        <Label>
                                          {props.t("Category")}: {item.category}
                                        </Label>
                                      </Col>
                                    </Row>
                                    <ToolkitProvider
                                      bootstrap4
                                      keyField="item_id"
                                      data={item.items}
                                      columns={columns_cartitems}
                                      noDataIndication={props.t(
                                        "No data to display."
                                      )}
                                      search
                                    >
                                      {(props) => (
                                        <div>
                                          <BootstrapTable
                                            striped
                                            hover
                                            condensed
                                            cellEdit={cellEditFactory({
                                              mode: "click",
                                              blurToSave: true,
                                              afterSaveCell: (
                                                oldValue,
                                                newValue,
                                                row,
                                                column
                                              ) => {
                                                // console.log(row.price, row.quantity);
                                              },
                                            })}
                                            {...props.baseProps}
                                          />
                                        </div>
                                      )}
                                    </ToolkitProvider>
                                  </>
                                );
                              }
                            })}
                        </Col> */}

                        <Col lg={12}>
                                    <ToolkitProvider
                                      bootstrap4
                                      keyField="item_id"
                                      data={cartItems}
                                      columns={columns_cartitems}
                                      noDataIndication={props.t(
                                        "No data to display."
                                      )}
                                      search
                                    >
                                      {(props) => (
                                        <div>
                                          <BootstrapTable
                                            striped
                                            hover
                                            condensed
                                            cellEdit={cellEditFactory({
                                              mode: "click",
                                              blurToSave: true,
                                              afterSaveCell: (
                                                oldValue,
                                                newValue,
                                                row,
                                                column
                                              ) => {
                                                // console.log(row.price, row.quantity);
                                              },
                                            })}
                                            {...props.baseProps}
                                          />
                                        </div>
                                      )}
                                    </ToolkitProvider>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                                         <FormGroup className="mb-0 text-center">
                                           <div>
                                             <Button
                                               type="submit"
                                               color="primary"
                                               style={{width:"100px"}}
                                               className="mr-2"
                                               disabled={categorisezItem?.length <= 0 || disableSubmit || isLoading}
                                               onClick={() => handleSubmitRequisition()}
                                             >
                                             {disableSubmit ? <Spinner size="sm" /> : props.t("Generate")} 
                                             </Button>
                                             <Button
                                               type="submit"
                                               style={{width:"140px"}}
                                               disabled={categorisezItem?.length <= 0 || disableSubmit || isLoading}
                                               onClick={() => handleSubmitDraft()}
                                             >
                                               {isLoading ?<Spinner size={"sm"} /> :props.t("Save as Draft")}
                                             </Button>
                                           </div>
                                         </FormGroup>
                                       </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>

          {/* Add unit modal  */}
          <EnterQuantityForPoModal
          isOpen={selectUnitModal}
          toggle={handleCloseModal}
          onSubmit={handleAddUnits}
          item={selectedProducts}
          selectedUnits={selectedRowsUnit}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedProducts}
          />
         {/* Update unit modal  */}
            <UpdateQuantityForPoModal
          isOpen={editUnitModal}
          toggle={()=>setEditUnitModal(false)}
          onSubmit={handleUpdateUnit}
          item={selectedProducts}
          selectedUnits={selectedRowsUnit}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedProducts}
          />

           {/* Draft Modal start  */}
                    <AllDrafts
                      isOpen={openDraftModal}
                      toggle={() => setOpenDraftModal(!openDraftModal)}
                      title={props.t("All Draft Purchase Orders")}
                      data={draftOrders}
                      keyField="_id"
                      selectRow={selectDraftPORow}
                      noDataMessage={props.t("No data to display.")}
                      onDelete={()=>loadDraftOrders()}
                      showSupplierColumn={false}
                      storeType="Central Kitchen"
                    />
                    {/* Draft Modal end  */}

        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(FinishedProductPOGeneration))
);
